import APIClient from '@/shared/http/clients/api'

const resourceName = 'bens-associados'
const APICore = process.env.APIBaseURLCore

const Search = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}&page=${index}&size=${limit}`, config)

const PatrimonyRepository = {
  Search
}

export default PatrimonyRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/patrimony.js